import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_TICKETS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the tickets.'),
      403: i18n.t('You are not allowed to fetch the tickets.'),
      404: i18n.t('The tickets you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the tickets.'),
      default: i18n.t('An error occurred fetching the tickets.')
    }
  },

  FETCH_TICKET: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the ticket.'),
      403: i18n.t('You are not allowed to fetch the ticket.'),
      404: i18n.t('The ticket you are trying to fetch does not exist.'),
      500: i18n.t('An error occurred fetching the ticket.'),
      default: i18n.t('An error occurred fetching the ticket.')
    }
  }
};
